import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  footerLogo: {
    width: 80,
    marginLeft: theme.spacing(2),
  },
}));
